import * as Yup from 'yup';

const validationSchema = Yup.object({
    fullname: Yup.string()
        .max(50, "toolong50")
        .required("required"),
    email: Yup.string()
        .email('invalidemail')
        .required("required"),
    phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'invalidphoneformat')
        .required("required"),
    address: Yup.string()
        .required("required"),
    zipcode: Yup.string()
        .required("required"),
    city: Yup.string()
        .required("required"),
    date: Yup.string()
        .required("required")
        .test('date-not-default', "required", function (value) {
            return value !== 'defaultdate';
        }),
    buildingType: Yup.string()
        .required("required")
        .test('building-not-default', "required", function (value) {
            return value !== 'defaultbuilding';
        }),
    singlecondo: Yup.object().when("buildingType", {
        is: buildingType => buildingType === "singlecondo",
        then: Yup.object().shape({
            condoassociation: Yup.string().required("required")
                .test('condoassociation-not-default', "required", function (value) {
                    return value !== 'defaultcondoassociation';
                }),
            nbstations: Yup.string().required("required")
                .test('nbstations-not-default', "required", function (value, context) {
                    return value !== 'defaultnbstations';
                }),
            hydrometerlocation: Yup.string().required("required")
                .test('hydrometerlocation-not-default', "required", function (value, context) {
                    return value !== 'defaulthydrometerlocation';
                }),
            hydrometerlocationothers: Yup.object().when("hydrometerlocation", {
                is: hydrometerlocation => hydrometerlocation === "otherspecify",
                then: Yup.object().shape({
                    hydrometerlocationspecify: Yup.string().required("required"),
                }),
                otherwise: Yup.object().shape({
                    hydrometerlocationspecify: Yup.string()
                })
            }),
            chargingstationlocation: Yup.string().required("required")
                .test('chargingstationlocation-not-default', "required", function (value, context) {
                    return value !== 'defaultchargingstationlocation';
                }),
            otherlocationspecify: Yup.object().when("chargingstationlocation", {
                is: chargingstationlocation => chargingstationlocation === "otherlocationspecify",
                then: Yup.object().shape({
                    chargingstationlocationspecify: Yup.string().required("required"),
                }),
                otherwise: Yup.object().shape({
                    chargingstationlocationspecify: Yup.string()
                })
            }),
            distancepanel: Yup.number().required("required"),
            distanceunits: Yup.string().required("required")
                .test('distanceunits-not-default', "required", function (value, context) {
                    return value !== 'defaultdistanceunits';
                }),
            knowmodel: Yup.string().required("required")
                .test('knowmodel-not-default', "required", function (value, context) {
                    return value !== 'defaultknowmodel';
                }),
            knowmodelyes: Yup.object().when("knowmodel", {
                is: knowmodel => knowmodel === "knowmodelyes",
                then: Yup.object().shape({
                    knowmodelspecify: Yup.string().required("required"),
                }),
                otherwise: Yup.object().shape({
                    knowmodelspecify: Yup.string()
                })
            }),
            files: Yup.array().min(1, "minimumonefile")
        }),
        otherwise: Yup.object().shape({
            condoassociation: Yup.string(),
            nbstations: Yup.string(),
            hydrometerlocation: Yup.string(),
            hydrometerlocationspecify: Yup.string(),
            chargingstationlocation: Yup.string(),
            chargingstationlocationspecify: Yup.string(),
            distancepanel: Yup.number(),
            distanceunits: Yup.string(),
            knowmodel: Yup.string(),
            knowmodelspecify: Yup.string(),
            files: Yup.array()
        })
    }),
    singlefamily: Yup.object().when("buildingType", {
        is: buildingType => buildingType === "singlefamily",
        then: Yup.object().shape({
            evready: Yup.string().required("required")
                .test('evready-not-default', "required", function (value) {
                    return value !== 'defaultevready';
                }),
            evreadyyes: Yup.object().when("evready", {
                is: evready => evready === "evreadyyes",
                then: Yup.object().shape({
                    breakersize: Yup.string()
                        .test('breakersize-not-default', "required", function (value, context) {
                            return value !== 'defaultbreakersize';
                        }),
                }),
                otherwise: Yup.object().shape({
                    breakersize: Yup.string(),
                })
            })
                .when("evready", {
                    is: evready => ["evreadyno", "evreadyidk"].includes(evready),
                    then: Yup.object().shape({
                        nbstations: Yup.string().required("required")
                            .test('nbstations-not-default', "required", function (value, context) {
                                return value !== 'defaultnbstations';
                            }),
                        next5years: Yup.string().required("required")
                            .test('next5years-not-default', "required", function (value, context) {
                                return value !== 'defaultnext5years';
                            }),
                        panellocation: Yup.string().required("required")
                            .test('panellocation-not-default', "required", function (value, context) {
                                return value !== 'defaultpanellocation';
                            }),
                        panellocationsothers: Yup.object().when("panellocation", {
                            is: panellocation => panellocation === "otherspecify",
                            then: Yup.object().shape({
                                panellocationspecify: Yup.string().required("required"),
                            }),
                            otherwise: Yup.object().shape({
                                panellocationspecify: Yup.string()
                            })
                        }),
                        otherpanels: Yup.string().required("required")
                            .test('otherpanels-not-default', "required", function (value, context) {
                                return value !== 'defaultotherpanels';
                            }),
                        otherpanelsyes: Yup.object().when("otherpanels", {
                            is: otherpanels => otherpanels === "otherpanelsyes",
                            then: Yup.object().shape({
                                otherpanelsspecify: Yup.string().required("required"),
                            }),
                            otherwise: Yup.object().shape({
                                otherpanelsspecify: Yup.string()
                            })
                        }),
                        chargingstationlocation: Yup.string().required("required")
                            .test('chargingstationlocation-not-default', "required", function (value, context) {
                                return value !== 'defaultchargingstationlocation';
                            }),
                        otherlocationspecify: Yup.object().when("chargingstationlocation", {
                            is: chargingstationlocation => chargingstationlocation === "otherlocationspecify",
                            then: Yup.object().shape({
                                chargingstationlocationspecify: Yup.string().required("required"),
                            }),
                            otherwise: Yup.object().shape({
                                chargingstationlocationspecify: Yup.string()
                            })
                        }),
                        distancepanel: Yup.number().required("required"),
                        distanceunits: Yup.string().required("required")
                            .test('distanceunits-not-default', "required", function (value, context) {
                                return value !== 'defaultdistanceunits';
                            })
                    }),
                    otherwise: Yup.object().shape({
                        nbstations: Yup.string(),
                        next5years: Yup.string(),
                        panellocation: Yup.string(),
                        panellocationspecify: Yup.string(),
                        otherpanels: Yup.string(),
                        otherpanelsspecify: Yup.string(),
                        chargingstationlocation: Yup.string(),
                        chargingstationlocationspecify: Yup.string(),
                        distancepanel: Yup.number(),
                        distanceunits: Yup.string()
                    })
                }),
            knowmodel: Yup.string().required("required")
                .test('knowmodel-not-default', "required", function (value, context) {
                    return value !== 'defaultknowmodel';
                }),
            knowmodelyes: Yup.object().when("knowmodel", {
                is: knowmodel => knowmodel === "knowmodelyes",
                then: Yup.object().shape({
                    knowmodelspecify: Yup.string().required("required"),
                }),
                otherwise: Yup.object().shape({
                    knowmodelspecify: Yup.string()
                })
            }),
            knowmodelno: Yup.object().when("knowmodel", {
                is: knowmodel => knowmodel === "knowmodelno",
                then: Yup.object().shape({
                    maxpower: Yup.string().required("required")
                        .test('maxpower-not-default', "required", function (value, context) {
                            return value !== 'defaultmaxpower';
                        })
                }),
                otherwise: Yup.object().shape({
                    maxpower: Yup.string()
                })
            }),
            maxpoweridk: Yup.object().when("knowmodelno.maxpower", {
                is: maxpower => maxpower === "maxpoweridk",
                then: Yup.object().shape({
                    maxpowercarmodel: Yup.string().required("required")
                }),
                otherwise: Yup.object().shape({
                    maxpowercarmodel: Yup.string()
                })
            }),
            files: Yup.array().min(1, "minimumonefile")
        }),
        otherwise: Yup.object().shape({
            evready: Yup.string(),
            breakersize: Yup.string(),
            nbstations: Yup.string(),
            next5years: Yup.string(),
            next5yearsspecify: Yup.string(),
            panellocation: Yup.string(),
            panellocationspecify: Yup.string(),
            otherpanels: Yup.string(),
            otherpanelsspecify: Yup.string(),
            chargingstationlocation: Yup.string(),
            chargingstationlocationspecify: Yup.string(),
            distancepanel: Yup.number(),
            distanceunits: Yup.string(),
            knowmodel: Yup.string(),
            knowmodelspecify: Yup.string(),
            maxpower: Yup.string(),
            maxpowercarmodel: Yup.string(),
            files: Yup.array()
        })
    })
});

export default validationSchema;